import { render, staticRenderFns } from "./PromotedLandlords.vue?vue&type=template&id=639bcb14&"
import script from "./PromotedLandlords.vue?vue&type=script&lang=js&"
export * from "./PromotedLandlords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports